<template>
  <section class="sec sec-alt" id="contact">
    <div class="sec-inner">
      <div class="contact-wrap">
        <div class="contact-left">
          <div class="sec-eyebrow">联系</div>
          <h2 class="sec-title">联系方式</h2>
          <p class="sec-sub">
            医疗与医保信息化、慢病管理、长护险、小程序开发相关的合作与交流都欢迎。
            电话或微信联系最快，也可以发送邮件。
          </p>
          <div class="contact-org">
            <div class="org-name">{{ company.name }}</div>
            <div class="org-meta">{{ company.location }} · {{ company.tagline }}</div>
          </div>
        </div>

        <div class="contact-right">
          <WechatCopy />
          <a class="contact-row" :href="'tel:' + profile.phone">
            <span class="contact-label">手机 / 微信</span>
            <span class="contact-value strong">{{ profile.phone }}</span>
          </a>
          <a class="contact-row" :href="'mailto:' + profile.email">
            <span class="contact-label">邮箱</span>
            <span class="contact-value">{{ profile.email }}</span>
          </a>
          <a
            class="contact-row"
            :href="company.site"
            target="_blank"
            rel="noopener"
          >
            <span class="contact-label">公司官网</span>
            <span class="contact-value">sdruizer.com &rarr;</span>
          </a>
          <a
            class="contact-row"
            :href="profile.csdn"
            target="_blank"
            rel="noopener"
          >
            <span class="contact-label">CSDN</span>
            <span class="contact-value">1345 篇原创 &rarr;</span>
          </a>
          <a
            class="contact-row"
            :href="profile.github"
            target="_blank"
            rel="noopener"
          >
            <span class="contact-label">GitHub</span>
            <span class="contact-value">开源项目 &rarr;</span>
          </a>
          <a
            class="contact-row"
            :href="profile.gitee"
            target="_blank"
            rel="noopener"
          >
            <span class="contact-label">Gitee</span>
            <span class="contact-value">国内仓库 &rarr;</span>
          </a>
          <div class="contact-row static">
            <span class="contact-label">微信公众号</span>
            <span class="contact-value">{{ accountNames }}</span>
          </div>
          <router-link class="contact-row" to="/message">
            <span class="contact-label">留言板</span>
            <span class="contact-value">随便说点什么 &rarr;</span>
          </router-link>
        </div>
      </div>

      <div class="accounts" v-if="accountsWithQr.length">
        <div class="account" v-for="a in accountsWithQr" :key="a.name">
          <img class="account-qr" :src="a.qrcode" :alt="a.name + ' 二维码'" data-zoom />
          <div class="account-name">{{ a.name }}</div>
          <div class="account-desc">{{ a.followers }} 关注</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { accounts, profile, company } from "@/assets/js/profile";
import WechatCopy from "@/components/WechatCopy";

export default {
  name: "ContactSection",
  components: { WechatCopy },
  data() {
    return { accounts, profile, company };
  },
  computed: {
    // 配了二维码图才走图片展示，没配就退回一行文字，避免破图
    accountsWithQr() {
      return this.accounts.filter(a => a.qrcode);
    },
    accountNames() {
      return this.accounts.map(a => a.name).join("、");
    }
  }
};
</script>

<style scoped>
.contact-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.contact-left {
  flex: 1 1 420px;
  min-width: 300px;
  padding-right: 40px;
}
.contact-org {
  margin-top: 30px;
  padding-top: 22px;
  border-top: 1px solid var(--border);
}
.org-name {
  font-size: 15.5px;
  font-weight: 500;
  color: var(--ink);
}
.org-meta {
  font-size: 13.5px;
  color: var(--ink-faint);
  margin-top: 6px;
}
.contact-right {
  flex: 0 1 440px;
  min-width: 300px;
  border-top: 1px solid var(--border);
}
.contact-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 4px;
  border-bottom: 1px solid var(--border);
  transition: padding-left 0.18s ease;
}
.contact-row:not(.static):hover {
  padding-left: 10px;
}
.contact-label {
  font-size: 14.5px;
  color: var(--ink);
  font-weight: 500;
}
.contact-value {
  font-size: 14px;
  color: var(--ink-soft);
}
.contact-value.strong {
  font-size: 16px;
  font-weight: 600;
  color: var(--accent);
  letter-spacing: 0.4px;
}
.contact-row:not(.static):hover .contact-value {
  color: var(--accent);
}
.accounts {
  display: flex;
  flex-wrap: wrap;
  margin-top: 44px;
}
.account {
  margin-right: 30px;
  text-align: center;
}
.account-qr {
  cursor: zoom-in;
  width: 124px;
  height: 124px;
  border-radius: 8px;
  border: 1px solid var(--border);
  display: block;
}
.account-name {
  font-size: 14px;
  color: var(--ink);
  margin-top: 10px;
}
.account-desc {
  font-size: 12.5px;
  color: var(--ink-faint);
  margin-top: 2px;
}

@media (max-width: 760px) {
  .contact-left {
    padding-right: 0;
    margin-bottom: 30px;
  }
}
</style>
